import { transitionTravelInsuranceTravelDetailsForm } from '../../../actions/travelSs/travelDetails';
import { getTravelDetailsForm } from '../../../selectors/travelSs/travelDetails';
import { FIELD_STATUS } from '../../../reducers/status';

export const travelDetailsFormRules = (store, next, action) => {
    const result = next(action);
    const travelDetailsForm = getTravelDetailsForm(store.getState());

    const travelDetailsFormValid = validateTravelDetailsFormDetails(travelDetailsForm); // true false
    const formAction = travelDetailsFormValid
        ? transitionTravelInsuranceTravelDetailsForm.formValid()
        : transitionTravelInsuranceTravelDetailsForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateTravelDetailsFormDetails = (formFields) => {
    let ugandanIdChecks = true;

    if (formFields?.nationalityType?.value === 'South Sudan') {
        ugandanIdChecks = formFields?.idNumber?.status === FIELD_STATUS.VALID && formFields?.idUpload?.value;
    }

    return (
        ugandanIdChecks &&
        formFields?.nationalityType?.status === FIELD_STATUS.VALID &&
        formFields?.passportNumber?.status === FIELD_STATUS.VALID &&
        formFields?.profession?.status === FIELD_STATUS.VALID &&
        formFields?.dob?.status === FIELD_STATUS.VALID &&
        formFields?.phoneNumber?.status === FIELD_STATUS.VALID &&
        formFields?.email?.status === FIELD_STATUS.VALID &&
        formFields?.postalAddress?.status === FIELD_STATUS.VALID &&
        formFields?.town?.status === FIELD_STATUS.VALID &&
        formFields?.passportBiodata?.status === FIELD_STATUS.VALID
    );
};
